import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import Loader from '../components/Loader';
import NotFound from '../pages/NotFound';
import AllUsers from './AllUsers';

const Admin = () => {
  const [isAdmin, setIsAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        try {
          // Fetch user role from Firestore
          const userDocRef = doc(db, 'online', currentUser.uid);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            const userData = userDoc.data();
            // Check if the role is 'admin'
            setIsAdmin(userData.role === 'admin');
          } else {
            console.warn('No user document found in Firestore');
            setIsAdmin(false);
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
      setLoading(false);
    });

    // Cleanup on unmount
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (isAdmin === false) {
    return <NotFound />;
  }


  return (
    <div>
      <AllUsers />
    </div>
  );
};

export default Admin;
